import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Settings } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminLoginModal() {
  const [password, setPassword] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/admin/login`, { password });
      if (response.data.success) {
        localStorage.setItem('adminAuthenticated', 'true');
        toast.success('Acceso de Administrador Concedido');
        setIsOpen(false);
        navigate('/admin');
      } else {
        toast.error('Contraseña Incorrecta');
      }
    } catch (error) {
        toast.error('Error de Inicio de Sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button 
            variant="ghost" 
            size="icon" 
            className="text-zinc-400 hover:text-white hover:bg-zinc-800 transition-all" 
            title="Admin Access"
        >
          <Settings className="h-5 w-5" />
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-zinc-950 border-zinc-800 text-white sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center text-xl font-bold text-red-500 uppercase tracking-widest">
            Admin Access
          </DialogTitle>
        </DialogHeader>
        
        <form onSubmit={handleLogin} className="space-y-6 mt-4">
            <div className="space-y-2">
                <div className="relative">
                    <Lock className="absolute left-3 top-3 h-5 w-5 text-zinc-500" />
                    <Input 
                        type="password" 
                        placeholder="Contraseña" 
                        className="pl-10 bg-zinc-900/50 border-zinc-800 focus:border-red-600 focus:ring-red-600 h-12 text-lg text-center"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
            </div>

            <Button 
                type="submit" 
                className="w-full bg-red-600 hover:bg-red-700 text-white h-12 font-bold uppercase tracking-wider"
                disabled={loading}
            >
                {loading ? 'Verificando...' : 'Entrar'}
            </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
